<template>
  <div class="cbox-p14 table-main">
    <TableHeader :refTable="refTable" storageKey="hiddenColumns_allcation" @onRefresh="getTableData()">
      <slot></slot>
    </TableHeader>

    <el-table ref="table" :data="tableData" border stripe height="100%" style="width: 100%" v-loading="tableLoading">
      <el-table-column label="序号" align="center" width="50">
        <template v-slot="{ $index }">
          <span>{{ (searchModel.pageNum - 1) * searchModel.pageSize + $index + 1 }}</span>
        </template>
      </el-table-column>
      <el-table-column label="委托编号" width="160" align="center">
        <template v-slot="{ row }">
          <el-link type="primary" @click="handleProcess(row)">{{ row.reportCodeStart }}</el-link>
        </template>
      </el-table-column>
      <el-table-column prop="client" label="委托单位" align="center"></el-table-column>
      <el-table-column prop="projectName" label="项目名称" align="center" min-width="220"></el-table-column>
      <el-table-column prop="sfcn" label="委托单位联系人" align="center"></el-table-column>

      <el-table-column label="操作" v-if="queryType == '0'" width="120" align="center">
        <template v-slot="{ row }">
          <el-link type="primary" @click="handleAllocation(row, 0)">分配</el-link>
          <!-- <el-link  type="danger" @click="handleReturn(row)">退回</el-link> -->
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      :current-page="searchModel.pageNum"
      :page-size="searchModel.pageSize"
      background
      layout="total, prev, sizes ,pager, next, jumper"
      :total="dataTotal"
      @current-change="onCurrentChange"
      @size-change="onSizeChange"
    ></el-pagination>

    <!-- 流程信息 -->
    <ProcessDialog :visible.sync="processVisible" :activeId="activeRowId" />
    <!-- 退回 -->
    <ReturenDialog :visible.sync="returnVisible" :activatedRow="activatedRow" @refreshData="getTableData()" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import TableHeader from '@/components/TableHeader';
import ProcessDialog from '@/components/BusinessComponents/ProcessDialog';
import ReturenDialog from '@/components/BusinessComponents/ReturenDialog';

import { getUndistributeEntrustmentSetList, getDistributeEntrustmentSetList } from '@/api/entrust';

export default {
  components: { TableHeader, ProcessDialog, ReturenDialog },
  props: {
    tableType: {
      type: String,
      default: ''
    },
    // 0:未分配 1:已分配
    queryType: {
      type: String,
      default: '1'
    }
  },
  data() {
    return {
      refTable: null,
      searchModel: {
        pageNum: 1,
        pageSize: 20,
        orderType: 2
      },
      dataTotal: 0,
      tableLoading: false,
      tableData: [],
      activatedRow: {},
      activeRowId: null,
      allocationVisible: false,
      allocationType: 0, // 0:分配操作 1:重新分配操作
      addSamplesVisible: false,
      processVisible: false,
      returnVisible: false
    };
  },
  computed: {
    ...mapGetters(['userId'])
  },
  watch: {
    queryType() {
      this.getTableData(true);
    }
  },
  methods: {
    setSearchModel(val) {
      this.searchModel = { ...this.searchModel, ...val };
      this.getTableData(true);
    },
    onCurrentChange(pageNum) {
      this.searchModel.pageNum = pageNum;
      this.getTableData();
    },
    onSizeChange(pageSize) {
      this.searchModel.pageNum = 1;
      this.searchModel.pageSize = pageSize;
      this.getTableData(true);
    },
    async getTableData(isFirstPage = false) {
      if (isFirstPage) this.searchModel.pageNum = 1;
      this.tableLoading = true;

      const startDate = this.searchModel?.dateRange?.[0] ?? null;
      const endDate = this.searchModel?.dateRange?.[1] ?? null;
      const startTime = startDate ? startDate + ' 00:00:00' : null;
      const endTime = endDate ? endDate + ' 23:59:59' : null;

      let resData = {};
      if (this.queryType == '0') {
        const { data } = await getUndistributeEntrustmentSetList({
          ...this.searchModel,
          startTime,
          endTime,
          leaderId: this.userId
        });
        resData = data;
      } else {
        const { data } = await getDistributeEntrustmentSetList({
          ...this.searchModel,
          startTime,
          endTime,
          leaderId: this.userId
        });
        resData = data;
      }
      this.dataTotal = resData.count;
      this.tableData = resData.list || [];

      this.tableLoading = false;
    },
    handleProcess(row) {
      this.activeRowId = row.id;
      this.processVisible = true;
    },
    handleReturn(row) {
      this.activatedRow = row;
      this.returnVisible = true;
    },
    handleAllocation(row, allocationType) {
      this.$router.push(`/allocation/${row.id}`);
    },
    handleAddSamples(row) {
      this.activatedRow = row;
      this.addSamplesVisible = true;
    }
  },
  created() {},
  mounted() {
    this.refTable = this.$refs.table;
  },
  activated() {
    this.getTableData();
    this.$nextTick(() => {
      this.$refs.table.doLayout(); // 重置表格布局
    });
  }
};
</script>
<style lang="scss" scoped></style>
